import Vue from 'vue'
import moment from 'moment'

Vue.filter('shorttime', function (val, tz = undefined) {
  // Without this guard moment(undefined) means "now", so an absent timestamp renders as
  // the CURRENT time -- confidently wrong rather than obviously blank. That exact
  // failure already shipped once (a renewal date invented from a field the API never
  // emits). The sibling `datetime` filter has always guarded; this one did not, and
  // every call site was safe only because each happened to carry its own v-if.
  if (!val) return ''

  const parsed = tz ? moment(val).tz(tz) : moment(val)
  if (!parsed.isValid()) return ''

  return parsed.format('h:mma MM/DD')
})
